import { createEventTracker } from '@fullstory/analytics';
import { ClickedPageFlowNodeAnalytics } from './types';

export const trackClickedPageFlowNode =
  createEventTracker<ClickedPageFlowNodeAnalytics>('Clicked Page Flow Node');
